import useLanguage from "../i18n/useLanguage";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import AiUseCases from "../components/ai-service/AiUseCases";
import AiOrderSteps from "../components/ai-service/AiOrderSteps";
import AiFaq from "../components/ai-service/AiFaq";
import AiExamples from "../components/ai-service/AiExamples";
import { AI_ORDER_URL } from "../data/products";

export default function AiServicePage() {
  const { t } = useLanguage();
  return (
    <div className="font-sans bg-black text-white min-h-screen">
      <Navbar />
      <main className="max-w-5xl mx-auto px-6 pt-36 pb-12">
        <section className="relative pb-14">
          <p className="text-amber-300 text-sm uppercase tracking-[0.25em] mb-6">{t("AI Creative · Titik Senyap Studio")}</p>
          <h1 className="text-4xl sm:text-6xl font-bold leading-tight max-w-4xl">{t("Jasa Foto & Video AI untuk")}{" "}<span className="text-amber-300">{t("Affiliate, Konten, dan Promosi Produk")}</span></h1>
          <p className="text-gray-400 text-lg leading-relaxed mt-7 max-w-2xl">{t("Ubah foto produkmu menjadi bahan konten. Pesan foto produk AI, video konten TikTok dan Reels, atau visual iklan cinematic lewat form Flow.")}</p>
          <div className="flex flex-wrap gap-4 items-center mt-9"><a href={AI_ORDER_URL} className="rounded-xl bg-amber-300 text-black px-6 py-4 font-bold hover:bg-amber-400">{t("Pesan Sekarang")}</a><a href="#ai-order-steps" className="text-gray-300 underline underline-offset-4 hover:text-amber-300">{t("Lihat cara pemesanan")}</a></div>
          <p className="text-sm text-gray-500 mt-4">{t("Pilih Video Konten Produk, Cinematic TV Ads, atau Photo Studio di form order.")}</p>
        </section>
        <AiExamples />
        <AiUseCases />
        <AiOrderSteps />
        <AiFaq />
      </main>
      <Footer />
    </div>
  );
}
